/* AVERA — Journal : apparition douce au scroll (.facil-journal-reveal → .is-in). */
(function () {
  'use strict';
  if (window.__facilJournalReveal) return;
  window.__facilJournalReveal = true;
  var els = document.querySelectorAll('.facil-journal-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  Array.prototype.forEach.call(els, function (el) { io.observe(el); });
})();
